module.exports = {
  serverURL: 'https://ebkarriere.s3m-werkstatt.de'
  //serverURL: 'https://bz-af.de'
  //serverURL: 'https://stuck-komzet.de'
  // serverURL: 'http://localhost:8000'
}
